import React, { useContext, useEffect } from 'react'
import { getHttp } from 'src/api'
import { PATH_API, bindLocationToPlace } from 'src/helpers'
import { useAppContext } from 'src/helpers/app'

import { Unserviceable } from './components'
import { EndQuiz } from './components/EndQuiz'
import { MetBefore } from './components/MetBefore/MetBefore'
import { GuineaPig } from './components/GuineaPig/GuineaPig'

import { QuizQuestionContext, QuizQuestionData, SCREEN_QUIZ_QUESTION } from './contextAPI'
import { IQuizData } from './contextAPI/quizQuestionContext'
import { EVENT_LOCATION_TYPE } from '../../types/question'

import { useExternalQuiz } from './useExternalQuiz'
import { YourDetails } from './components/NewFlow/YourDetailsPage/YourDetails'
import { GuestCount } from './components/NewFlow/GuestCountPage/GuestCount'
import { NewPlanningStage } from './components/NewFlow/PlanningStagePage/NewPlanningStage'
import { MetBeforeAfterSubmitted } from './components/MetBeforeAfterSubmitted/MetBeforeAfterSubmitted'
import { Availability } from './components/NewFlow/AvailabilityPage/Availability'
import { ColorPaletteComponentV2 } from './components/NewFlow/ColorPalettePage/ColorPaletteComponentV2'
import { NewBudget } from './components/NewFlow/BudgetPage/NewBudget'
import { ContactInfo } from './components/NewFlow/ContactInfo/ContactInfo'
import { EssentialsCollection } from './components/NewFlow/EssentialsCollection/EssentialsCollection'
import { Availability as PinterestAvailability } from './pinterestFlow/Availability/Availability'
import { LinkYourBoard } from './pinterestFlow/LinkYourBoard/LinkYourBoard'
import { PinterestBoard } from './pinterestFlow/PinterestBoard/PinterestBoard'
import { ImportPins } from './pinterestFlow/ImportPins/ImportPins'
const quizQuestionScreens: {
  [label: string]: React.ReactNode
} = {
  [SCREEN_QUIZ_QUESTION.MET_BEFORE]: <MetBefore />,
  [SCREEN_QUIZ_QUESTION.END_QUIZ]: <EndQuiz />,
  [SCREEN_QUIZ_QUESTION.AFTER_QUIT_SUBMIT]: <GuineaPig />,
  [SCREEN_QUIZ_QUESTION.MET_BEFORE_AFTER_SUBMITTED]: <MetBeforeAfterSubmitted />,
  // New flow
  [SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE]: <ColorPaletteComponentV2 />,
  [SCREEN_QUIZ_QUESTION.NEW_AVAILABILITY_PAGE]: <Availability />,
  [SCREEN_QUIZ_QUESTION.YOUR_DETAILS]: <YourDetails />,
  [SCREEN_QUIZ_QUESTION.PLANNING_STAGE]: <NewPlanningStage />,
  [SCREEN_QUIZ_QUESTION.GUEST_COUNT]: <GuestCount />,
  [SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE]: <NewBudget />,
  [SCREEN_QUIZ_QUESTION.ESSENTIALS_COLLECTION_PAGE]: <EssentialsCollection />,
  [SCREEN_QUIZ_QUESTION.CONTACT_INFO]: <ContactInfo />,
  // Pinterest flow
  [SCREEN_QUIZ_QUESTION.PINTEREST_AVAILABILITY]: <PinterestAvailability />,
  [SCREEN_QUIZ_QUESTION.PINTEREST_LINK_YOUR_BOARD]: <LinkYourBoard />,
  [SCREEN_QUIZ_QUESTION.PINTEREST_BOARD]: <PinterestBoard />,
  [SCREEN_QUIZ_QUESTION.IMPORT_PINS]: <ImportPins />,
}

interface IQuizQuestionBaseProps {
  hardScreen?: SCREEN_QUIZ_QUESTION
}

export const QuizQuestionBase = ({ hardScreen }: IQuizQuestionBaseProps) => {
  const { screen, recordResponse, setQuizQuestionData, setQuizScreen, setData, data, setRecordResponse } = useContext(
    QuizQuestionContext
  )
  const { quizSession } = useAppContext()
  useExternalQuiz()

  useEffect(() => {
    if (quizSession) {
      const newData: IQuizData = {}
      newData.weddingDate = {
        weddingDate: quizSession?.event?.date,
        fullName: `${quizSession?.customer?.firstName || ''} ${quizSession?.customer?.lastName || ''}`,
        firstName: quizSession?.customer?.firstName,
        lastName: quizSession?.customer?.lastName,
        partnerName: quizSession?.customer?.partnerName,
        emailAddress: quizSession?.customer?.emailAddress,
        phoneNumber: quizSession?.customer?.phoneNumber,
      }
      newData.planningStage = {
        vendors: data.planningStage?.vendors ?? {},
        stage: quizSession.event?.planningStage,
        intent: data.planningStage?.intent ?? '',
      }
      const ceremonyLocation = quizSession.locations?.find((loc) => loc.type === EVENT_LOCATION_TYPE.CEREMONY)
      const tempLocation = {
        type: (ceremonyLocation?.type as EVENT_LOCATION_TYPE) || EVENT_LOCATION_TYPE.CEREMONY,
        place: '',
        venue: ceremonyLocation?.name || '',
        city: ceremonyLocation?.city || '',
        state: ceremonyLocation?.state || '',
        streetAddress: ceremonyLocation?.streetAddress || '',
        zipCode: ceremonyLocation?.zipCode || '',
        placeId: ceremonyLocation?.venue?.ggPlaceId || '',
        country: ceremonyLocation?.country || '',
      }
      newData.location = [
        {
          ...tempLocation,
          place: bindLocationToPlace(tempLocation) || '',
        },
      ]
      newData.budget = quizSession.event?.budget || 3000
      newData.colorPalette = quizSession.colorPalette
      newData.colorPreference = quizSession.customer?.colorPreference
      newData.inspirationPhotos = quizSession.inspirations
      newData.stemPreferences = quizSession.stemPreferences
      newData.referralSource = quizSession.event?.referralSource

      if (quizSession.proposal?.hadProposal) {
        setRecordResponse({ proposal: quizSession.proposal })
        setQuizScreen(SCREEN_QUIZ_QUESTION.MET_BEFORE)
      }
      setData(newData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizSession])

  useEffect(() => {
    const initQuiz = async () => {
      try {
        const response = await getHttp(PATH_API.getQuizSessionData)
        const quizQuestionData: QuizQuestionData = response.data
        setQuizQuestionData(quizQuestionData)
      } catch (error) {}
    }
    initQuiz()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="quiz-question">{quizQuestionScreens[hardScreen ?? screen ?? ''] ?? <></>}</div>
      {/* only boolean */}
      {recordResponse?.serviceable === false && <Unserviceable />}
    </>
  )
}
